<template>
  <tr>
    <td>{{ item.Name }}</td>
    <!-- 以下手機版不顯示 -->
    <!-- <td v-show="!isMobile">{{ countyName }}</td> -->
    <!-- 以上手機版不顯示 -->
    <td v-if="canEditCounty">
      <v-icon class="ml-1 mr-1" @click.stop="editItem">edit</v-icon>
      <v-icon class="ml-1 mr-1" @click.stop="confirmDeleteItem">delete</v-icon>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    ...mapGetters(["canEditCounty"])
  },
  methods: {
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Name || "") + "」?")) return;
      this.$emit("remove", this.item);
    }
  }
};
</script>